<template>
	<div class="maintenance-page text-center">
		<div class="maintenance-page__image p-t-170">
			<img src="@/assets/images/maintenance.svg" alt="">
		</div>
		<div class="maintenance-page__title m-t-40 m-b-20">
			<h2 class="text-center" v-html="$t('maintenance.label.title')"></h2>
		</div>
		<div class="maintenance-page__content">
			<div class="maintenance-page__description">
				<p>Hi there,</p>
				<p>Swift back-end is going to be maintained in order to upgrade to a new version. It is expected to
					return to normal within 2 hours.</p>
				<p>You won't be able to access Swift during this time, but don't worry, your storefront switcher will
					continue working as normal.
					Just come back later or drop us a message if you have any urgent matters.</p>
				<p>Thanks for your understanding.</p>
				<p>Best regards,</p>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { types as typesAuth } from '@/modules/auth/constant'

export default {
	name: 'Maintenance',
	data() {
		return {
			title: this.$t('maintenance.title'),
			description: this.$t('maintenance.description')
		}
	},
	async created() {
		// if (!this.store) {
		// 	await this.getStore().then(res => {
		//         let { status = false} = res.data;
		//         if (status) {
		// 			this.initCripsChat()
		// 			this.initIntercom()
		// 		}
		// 	})
		//     .catch();
		// }
	},
	computed: {
		// ...mapGetters({
		//     store: typesAuth.getters.GET_STORE,
		// }),
	},
	methods: {
		// ...mapActions({
		//     getStore: typesAuth.actions.GET_STORE,
		// 	initCripsChat: typesAuth.actions.INIT_CRISP_CHAT,
		// 	initIntercom: typesAuth.actions.INIT_INTERCOM,
		// })
	}
}
</script>

<style lang="scss">
.maintenance-page {
	&__description {
		margin: auto;
		max-width: 954px;
		padding: 0 20px;
		text-align: left;

		p {
			color: $text-color-secondary;
		}
	}
}

//  .maintenance-page__content {
//  	max-width: 615px;
//  	margin: auto;
//  	font-size: 18px;
//  }
</style>